<div class="ribbon-corner shadow">
    <p>
        <span>We have just updated Twona,<br />you might want to <a routerLink="" (click)="reload()">reload now</a>!</span>
    </p>
</div>
